import Avatar from "@mui/material/Avatar";
import React from "react";

export default function InventoryImage({inventory, classes, ssx}) {

  return (
      <Avatar alt={inventory?.name}
              className={'m-2 ' + classes ? classes : ''}
              variant="rounded"
              sx={ssx || {width: '80%', height: 'auto', background: '#fff'}}
              src={inventory?.imageThumbUrl || inventory?.imageUrl}
              alt={inventory?.name}
      >
        <span style={{...ssx, height:'20px'} || {width: '80%', height: '20px', background: '#fff'}}></span>
      </Avatar>
  )
}